import React from 'react';
import { StoryblokComponent, storyblokEditable } from 'gatsby-source-storyblok';
import PropTypes from 'prop-types';
import Row from '../FlexboxGrid/Row.jsx';
import Col from '../FlexboxGrid/Col.jsx';
import { renderRichTextReact } from '../../utils/storyblokRichText';
import Separator from '../../icons/star-wars-separator.svg';

const FullWidthImageWithTwoColumnCaption = ({ blok }) => {
  const { description, image, title } = blok;

  return (
    <Col {...storyblokEditable(blok)} xs={8} md={10} lg={12}>
      <Row>
        <div className="w-full">
          {image?.map((nestedBlok) => (
            <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
          ))}
        </div>
      </Row>
      <Row>
        <div
          className="flex flex-wrap md:flex-nowrap w-full mt-[56px] sm:mt-[67px] lg:mt-[76px] md:justify-around
            items-center"
        >
          <p className="basis-full md:basis-auto typography-eyebrow-s sm:typography-eyebrow-l text-beige-100">
            {title}
          </p>
          <div className="basis-full md:basis-auto my-[26px] sm:my-[50px] md:my-0 px-0 md:px-[1em]">
            <Separator />
          </div>
          <div className="basis-full md:basis-[40%] max-w-[515px] typography-eyebrow-s">
            {blok.description && renderRichTextReact(description)}
          </div>
        </div>
      </Row>
    </Col>
  );
};

FullWidthImageWithTwoColumnCaption.propTypes = {
  blok: PropTypes.any.isRequired,
};

export default FullWidthImageWithTwoColumnCaption;
